import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Commune } from '../../models/commune';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommuneService extends CrudService<Commune> {
  protected basePath = 'commune'; // Specific for BookmarkService
  public instanceType = 'commune'; // Used in base service for constructing URLs

  getSlugs() {
    return this.http.get<string[]>(`${this.getBaseUrl()}/slugs`);
  }

  setDefaultBookmark(bookmarkId: string, internal: boolean) {
    return this.http.put(
      `${this.getBaseUrl()}/setDefaultBookmark/${this.userStore.commune()}`,
      {
        bookmarkId: bookmarkId,
        external: !internal,
      }
    );
  }

  setConfiguration(configuration: any) {
    return this.http
      .put(
        `${this.getBaseUrl()}/updateAtlasConfig/${this.userStore.commune()}`,
        {
          atlasConfig: configuration,
        }
      )
      .subscribe();
  }

  getLogoUploadUrl() {
    return `${this.getBaseUrl()}/uploadLogo/`;
  }

  removeLogo(path: string) {
    return this.http
      .post(`${this.getBaseUrl()}/removeLogo/`, { path })
      .subscribe();
  }

  getActiveCommune() {
    return lastValueFrom(
      this.http.get<Commune>(`${this.getBaseUrl()}/${this.userStore.commune()}`)
    );
  }

  override getItemsAsPromise() {
    return lastValueFrom(
      this.http.get<{ [key: string]: Commune }>(`${this.getBaseUrl()}`)
    );
  }

  constructor(http: HttpClient) {
    super(http);
  }
}
